// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"table_tableWrapper__XFgjy","table":"table_table__22pVP","headerCell":"table_headerCell__2HUqv"};